import { AVIS_INICIALITZAR, AVIS_INTRODUCCIO_COMPROVAR } from '../../../../actions/actionTypes';

export const ESTAT_INICIAL = false;

const esIdMeteorSeleccionatBuit = idMeteorSeleccionat => idMeteorSeleccionat === undefined || idMeteorSeleccionat === null || idMeteorSeleccionat === '';

const idMeteorSeleccionat = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {

        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_INTRODUCCIO_COMPROVAR: {
            const { idMeteorSeleccionat } = action.dades;
            return esIdMeteorSeleccionatBuit(idMeteorSeleccionat);
        }

        default:
            return state;
    }
};

export default idMeteorSeleccionat;



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/errors/idMeteorSeleccionat.js